import { createWithEqualityFn } from "zustand/traditional";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { modules, searchTerms } from "../../constants";
import { actions } from "../actions";
import { marketDynamicsView } from "../marketDynamics";
import { marketCoverageView, marketTotalsView } from "../marketShare";
import { agentSearchView, officeSearchView, transactionsSearchView, suggestedAgentsSearchView, agentMovementSearchView, savedAgentsSearchView } from "../proficiencyMetrics";
import { actions as pmActions } from "../proficiencyMetrics/actions";
import { actions as msActions } from "../marketShare/actions";
import { actions as mdActions } from "../marketDynamics/actions";
import { actions as amActions } from "../agentMetrics/actions";
import { actions as bdActions } from "../breakdowns/actions";
import { actions as amoveActions } from "../agentMovement/actions";
import { actions as dashboardActions } from "../dashboard/actions";
import { tableRetainActions } from "../tableRetain/actions";
import { dashboardView } from "../dashboard";

export const initialView = {
    id: undefined,
    search: {
        ownerId: undefined,
        mlsId: undefined,
        searchCriteria: undefined,
        representationCriteria: undefined,
        selectedOfficeListSearch: undefined,
    },
    loadedSearchCriteria: undefined,
    selectedMls: undefined,
    savedSearchList: undefined,
    selectedSavedSearch: undefined,
    timeFrameTitle: {
        mainTitle: searchTerms.selectType(searchTerms.timeFrame)
    },
    searchStatus: undefined,
    recruitingSoldTotals: undefined,
    summaryPinnedData: undefined,
    totals: undefined,
    retainedSortByModule: {},
    retainedFloatingFilterByModule: {},
    shouldShowChart: true,
};

export const initialSearchState = initialView => ({
    selectedModule: undefined,
    isLoading: false,
    isLoadingSearchData: false,
    listIsDirty: false,
    shouldCloseChips: false,
    shouldAgentNameRerunOnLoad: false,
    isManualSearch: false,
    [modules.proficiencyMetrics.transactions]: { ...transactionsSearchView({ ...initialView }) },
    [modules.proficiencyMetrics.offices]: { ...officeSearchView({ ...initialView }) },
    [modules.proficiencyMetrics.agents]: { ...agentSearchView({ ...initialView }) },
    [modules.proficiencyMetrics.suggestedAgents]: { ...suggestedAgentsSearchView({ ...initialView }) },
    [modules.proficiencyMetrics.agentMovement]: {...agentMovementSearchView({...initialView})},
    [modules.marketShare.totals]: { ...marketTotalsView({ ...initialView }) },
    [modules.marketShare.coverage]: { ...marketCoverageView({ ...initialView }) },
    [modules.marketDynamics.marketDynamics]: { ...marketDynamicsView({ ...initialView }) },
    [modules.proficiencyMetrics.savedAgents]: { ...savedAgentsSearchView({ ...initialView }) },
    [modules.dashboard.dashboard]: { ...dashboardView({ ...initialView }) },
    [modules.agentProduction.agentProduction]: { ...initialView }
});

let searchStore = (set, get) => ({
    ...initialSearchState(initialView),
    ...actions(set, get),
    ...pmActions(set, get),
    ...msActions(set, get),
    ...mdActions(set, get),
    ...bdActions(set, get),
    ...amActions(),
    ...amoveActions(set, get),
    ...tableRetainActions(set, get),
    ...dashboardActions(set, get),
});

export const useSearchStore = createWithEqualityFn(
    devtools(
        persist(
            searchStore,
            {
                name: 'search_state',
                storage: createJSONStorage(() => localStorage)
            }
        )
    )
);
